import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import ListingCard from '../components/ListingCard';
import { Button } from '@/components/ui/button';
import { Heart } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FavoritesPage() {
  const { user } = useAuth();
  const { language } = useLanguage();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) fetchFavorites();
  }, [user]);

  const fetchFavorites = async () => {
    try {
      const { data } = await axios.get(`${API}/favorites`);
      setListings(data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="favorites-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="font-outfit text-3xl font-bold text-[#121212] mb-2">
          {language === 'lv' ? 'Izlase' : 'Favorites'}
        </h1>
        <p className="text-[#5C5C5C] mb-8">{listings.length} {language === 'lv' ? 'saglabāti' : 'saved'}</p>

        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => <div key={i} className="bg-white rounded-xl h-72 animate-pulse" />)}
          </div>
        ) : listings.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {listings.map(l => <ListingCard key={l.id} listing={l} />)}
          </div>
        ) : (
          <div className="text-center py-16">
            <Heart className="w-16 h-16 mx-auto mb-4 text-[#5C5C5C] opacity-30" />
            <h3 className="font-outfit text-xl font-semibold text-[#121212] mb-2">
              {language === 'lv' ? 'Izlase ir tukša' : 'No favorites yet'}
            </h3>
            <p className="text-[#5C5C5C] mb-4">
              {language === 'lv' ? 'Pievienojiet sludinājumus izlasei, nospiežot sirsniņu' : 'Add listings by clicking the heart icon'}
            </p>
            <Link to="/listings">
              <Button className="bg-[#D97736] hover:bg-[#C06528] text-white">
                {language === 'lv' ? 'Pārlūkot sludinājumus' : 'Browse Listings'}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
